<p>{{'FORMS.TWOFACTORAUTH.OTP.TIMER' | translate : { time: remainingTime } }}</p>